import bugsnag from '@bugsnag/js';
import {ConfigService} from '@stackworx/react';

export default bugsnag({
  apiKey: '3a3c3b9236f7e0165463a8f7134294b5',
  releaseStage: ConfigService.stage,
  notifyReleaseStages: ['dev', 'prod'],
});
